
export type CrewRole =
  | "Director"
  | "Producer"
  | "Director of Photography"
  | "Camera Operator"
  | "First AC"
  | "Second AC"
  | "Gaffer"
  | "Best Boy Electric"
  | "Key Grip"
  | "Best Boy Grip"
  | "Production Designer"
  | "Audio Mixer"
  | "Photographer"
  | "Other";

export interface CrewMember {
  id: string;
  project_id: string;
  name: string;
  role: CrewRole;
  phone?: string;
  email?: string;
  notes?: string;
  created_at?: string;
  updated_at?: string;
  rate?: number;
  rate_type?: string;
}

export interface Contact {
  id: string;
  name: string;
  role: CrewRole;
  phone?: string;
  email?: string;
  notes?: string;
  user_id: string;
}

// Create a constant for crew roles that can be imported and used consistently
export const CREW_ROLES: CrewRole[] = [
  "Director",
  "Producer",
  "Director of Photography",
  "Camera Operator",
  "First AC",
  "Second AC",
  "Gaffer",
  "Best Boy Electric",
  "Key Grip",
  "Best Boy Grip",
  "Production Designer",
  "Audio Mixer",
  "Photographer",
  "Other",
];
